module.exports = __webpack_public_path__ + "static/media/image2.072a19c4.jpg";